import { useSelector } from "react-redux";
import { useAppDispatch } from "../store";
import { fetchCountryList, fetchUserLocation, globalSelector } from "../features/globalSlice";
import { useEffect } from "react";

export const useCountries = (options: { autoFetch?: boolean } = {}) => {
  const dispatch = useAppDispatch();
  const { countries, userLocation } = useSelector(globalSelector);

  const { autoFetch = false } = options;

  useEffect(() => {
    if (autoFetch && countries.data.length === 0 && !countries.isLoading) {
      dispatch(fetchCountryList());
    }
    if (autoFetch && !userLocation?.data) {
      dispatch(fetchUserLocation());
    }
  }, []);

  const refetchCountry = () => {
    dispatch(fetchCountryList());
  };

  return {
    ...countries,
    userLocation,
    refetchCountry,
  };
};
